import React from 'react';
import { Calendar, Clock, AlertTriangle } from 'lucide-react';

const DaysToTargetCard = ({ days, targetDate }) => {
  const isOverdue = days < 0;
  const isUrgent = days >= 0 && days <= 30;
  const isHealthy = days > 30;

  const formatDate = (dateString) => {
    if (!dateString) return 'Not set';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className={`rounded-lg border p-6 ${
      isOverdue
        ? 'bg-red-50 border-red-200'
        : isUrgent
          ? 'bg-amber-50 border-amber-200'
          : 'bg-white border-gray-200'
    }`}>
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-600">Target Audit Date</h3>
        {isOverdue && (
          <AlertTriangle className="w-5 h-5 text-red-500" />
        )}
      </div>

      <div className="flex items-baseline gap-2 mb-2">
        <div className={`text-4xl font-bold ${
          isOverdue
            ? 'text-red-700'
            : isUrgent
              ? 'text-amber-700'
              : 'text-gray-900'
        }`}>
          {Math.abs(days)}
        </div>
        <div className={`text-lg ${
          isOverdue
            ? 'text-red-600'
            : isUrgent
              ? 'text-amber-600'
              : 'text-gray-600'
        }`}>
          {isOverdue ? 'days overdue' : 'days remaining'}
        </div>
      </div>

      <div className="flex items-center gap-2 text-sm text-gray-600">
        <Calendar className="w-4 h-4" />
        <span>{formatDate(targetDate)}</span>
      </div>

      {isUrgent && !isOverdue && (
        <div className="mt-3 p-2 bg-white rounded border border-amber-200">
          <p className="text-xs text-amber-700 font-medium flex items-center gap-1">
            <Clock className="w-3 h-3" />
            Final push needed
          </p>
        </div>
      )}

      {isOverdue && (
        <div className="mt-3 p-2 bg-white rounded border border-red-200">
          <p className="text-xs text-red-700 font-medium">
            Consider extending audit date or expediting remaining tasks
          </p>
        </div>
      )}
    </div>
  );
};

export default DaysToTargetCard;
